import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsPushpin = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path
          d="M17.2217731,2.9434705V2.943469c-1.3958645-1.3958644-3.2518568-2.1656914-5.2228794-2.1656914
		c-1.9732351,0.0022116-3.827014,0.7720386-5.2228799,2.1656914C5.3801498,4.3393335,4.6125345,6.1931138,4.610323,8.1663494
		c0,3.9597435,6.8377457,14.6820202,6.9063234,14.7904148c0.1106071,0.1703358,0.2964268,0.2654572,0.4866724,0.2654572
		c0.1061831,0,0.2145767-0.0287571,0.3096991-0.0906963c0.0730009-0.0486679,0.1327286-0.1083965,0.1747599-0.1747608
		c0.0464554-0.0752125,1.8250217-2.8669415,3.5504971-6.0856152c2.2232075-4.1499882,3.3514023-7.0766602,3.3514023-8.7025881
		C19.3874664,6.1953268,18.6154251,4.3393345,17.2217731,2.9434705z M17.4385624,11.2522936
		c-0.4424286,1.1304073-1.0728912,2.4864531-1.8714752,4.0261087c-1.3516216,2.6081219-2.8603058,5.1189098-3.570405,6.2758617
		c-0.7123108-1.161377-2.2276316-3.6832256-3.5726175-6.2780733c-0.7985854-1.5396538-1.4290476-2.8957014-1.8714771-4.0261078
		C6.0238853,9.9028845,5.7562146,8.8653889,5.7562146,8.1641378C5.7208209,4.7264605,8.4904289,1.897125,11.9281054,1.8595183
		V1.859517c0.0221214,0,0.0442429,0,0.0663643,0c1.6414137,0,3.1899166,0.6304618,4.3645658,1.7807783
		c1.190136,1.1658018,1.8559914,2.7253659,1.8736897,4.3889008V8.168561
		C18.2327251,8.8675985,17.9650555,9.9050961,17.4385624,11.2522936z"
        />
        <path
          d="M11.9988937,4.1866961c-0.0022116,0-0.0022116,0-0.0044241,0c-1.0640421,0-2.0639334,0.4136705-2.8160629,1.163589
		c-0.7521305,0.75213-1.1680136,1.7520208-1.1702251,2.818274c0,1.0662556,0.411459,2.0661469,1.1635885,2.820488
		c0.7521305,0.7521305,1.7542324,1.1680145,2.8182764,1.1680145c0.0022116,0,0.0022116,0,0.0044231,0
		c1.0640421,0,2.0639334-0.4136715,2.8160629-1.1635895c0.7521305-0.7521305,1.1680136-1.7520199,1.1702261-2.8182755
		c0.0022116-1.0485578-0.4247322-2.0794177-1.1680126-2.8227C14.0606155,4.6003666,13.0607252,4.1866961,11.9988937,4.1866961z
		 M13.9986744,10.1683407c-0.5287037,0.5264912-1.2587118,0.8295555-1.9997807,0.8295555c-0.0022125,0-0.0022125,0-0.0044241,0
		c-0.7565546,0-1.4666548-0.2942152-2.0019932-0.827342C9.4549246,9.6352139,9.1584969,8.9251156,9.1562853,8.168561
		c0-0.7565546,0.2920036-1.4710779,0.827342-2.0064178c0.5353403-0.5353398,1.2454386-0.8317671,2.0019932-0.8339801
		c0.0022125,0,0.0022125,0,0.0044241,0c1.5617762,0,2.8337603,1.2675605,2.8381853,2.8293371
		C14.8304415,8.9052057,14.5273781,9.6374254,13.9986744,10.1683407z"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsPushpin;
